import React, { useState, useEffect } from 'react';
import styles from './inputDialog.module.scss';
import { Toast, Popup, TextArea } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import { ApiCore } from '../../api/index';
import dialog_btn_save from '../../static/images_ae/alkReport/dialog_btn_save.png';
import dialog_btn_close from '../../static/images_ae/alkReport/dialog_btn_close.png';
import dialog_input_content from '../../static/images_ae/alkReport/dialog_input_content.png';

const api = new ApiCore();

const InputDialog = (props: any) => {

    const [value, setValue] = useState<any>('');
    const [placeholder, setPlaceholder] = useState<any>(props.placeholder || '请输入内容......');

    useEffect(() => {
        setPlaceholder(props.placeholder || '请输入内容......');
    }, [])

    const onClose = () => {
        props.onClose();
    }

    const onSave = () => {
        if (!value) {
            Toast.show('内容不能为空')
        } else {
            props.onSave(value);
        }
    }

    return (
        <div className={styles.alk_component_dialog}>
            <div className={styles.dialog_wrap}>
                <div className={styles.content}>
                    <TextArea
                        placeholder={placeholder}
                        value={value}
                        onChange={val => {
                            setValue(val)
                        }}
                    />
                </div>
                <div className={styles.btns}>
                    <div className={styles.l_btn} onClick={onClose}></div>
                    <div className={styles.r_btn} onClick={onSave}></div>
                </div>
            </div>
            <div className={styles.mask}>
            </div>
        </div>
    )
}

export default withRouter(InputDialog);